import { TablePagination, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import {
  allLaboratory
} from "../../actions/laboratory-actions";
import { getActiveRegionals } from "../../actions/regional-actions";
import SearchLaboratory from "../../componentes/laboratory/searchLaboratory";
import TableLaboratory from "../../componentes/laboratory/tableLaboratory";
import { useStateValue } from "../../context/store";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import Search from "../../images/icons/search.svg";
import { styles } from "../styles";
import LaboratoryForm from "../../componentes/laboratory/laboratoryForm";
import { permissionsConstans } from "../../constansPermissions";

const Laboratory = (props) => {
  const classes = styles();
  const [{ filterLaboratory, breadCrumb }, dispatch] = useStateValue();
  const _ = require("lodash");
  const [regionales, setRegionales] = useState([]);
  const [openEdit, setOpenEdit] = useState(false);
  const [data, setData] = useState({
    laboratoryName: null,
    status: null,
    regionalId: null,
  });
  const [refresh, setRefresh] = useState(false);
  const [open, setOpen] = useState(false);

  if (breadCrumb?.handleOpenForm) {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Laboratorio",
      breadCrumbSubText: "Laboratorio",
      index: 22,
      handleOpenForm: false,
    });

    setTimeout(() => {
      setOpen(true);
    }, 100);
  }

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getrequest = async () => {
    const filterBody = {};
    if (data.laboratoryName !== "") {
      filterBody["laboratoryName"] = data.laboratoryName;
    }

    if (data.status !== "") {
      filterBody["status"] = data.status;
    }
    if (data.regionalId !== "") {
      filterBody["regionalId"] = data.regionalId;
    }
    const response = await allLaboratory(
      {
        laboratoryName: data.laboratoryName === "" ? null : data.laboratoryName,
        status: data.status === "" ? null : data.status,
        regionalId: data.regionalId === "" ? null : data.regionalId,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch
    );
    if (response && (response.status === 200 || response.status === 201)) {
      const data = response?.data?.medicalLabPage;
      if (data?.content?.length > 0) {
        setPaginadorResponse({
          data: data?.content,
          totalRows: data?.totalElements,
          pageSize: data?.size,
          pageNumber: data?.page,
        });
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.status !== 403
    ) {
      setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : response?.data?.error,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  if (
    filterLaboratory &&
    filterLaboratory?.isFilter &&
    data !== filterLaboratory.filter
  ) {
    const newfilter = filterLaboratory.filter;
    data.laboratoryName = newfilter.laboratoryName;
    data.status = newfilter.status;
    data.regionalId = newfilter.regionalId;
    paginadorRequest.page = 0;
    getrequest();
    dispatch({
      type: "SET_FILTER_LABORATORY",
      isFilter: false,
    });
  }

  useEffect(() => {
    getrequest();
  }, [paginadorRequest, refresh]);

  useEffect(() => {
    const getRegionales = async () => {
      const response = await getActiveRegionals();
      let orderRegionales = _.sortBy(
        response.data && response.data.regionalList,
        (o) => o.name
      );
      setRegionales(orderRegionales);
    };
    getRegionales();
  }, []);

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Laboratorio",
      breadCrumbSubText: "Laboratorio",
      index: 22,
      handleSaveOrderClauses: false,
    });
  }, []);

  const validationPermission = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "LAB");

    if (module?.functionalities?.some(
        (x) => x === permissionsConstans.LAB_CONSULTAR
      )
    ) {
      return (
        <React.Fragment>
          <SearchLaboratory />
        </React.Fragment>
      );
    } else return null;
  };

  return (
    <div>
      {validationPermission()}
      {open && (
        <LaboratoryForm
          open={open}
          setOpen={setOpen}
          handleClose={handleClose}
          setRefresh={setRefresh}
          refresh={refresh}
        />
      )}

      {paginadorResponse?.data?.map((info) => (
        <TableLaboratory
          data={info}
          regionales={regionales}
          openEdit={openEdit}
          setOpenEdit={setOpenEdit}
          setMessage={setMessage}
          message={message}
          setRefresh={setRefresh}
          refresh={refresh}
        />
      ))}

      {paginadorResponse?.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          labelRowsPerPage="Registros por página"
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
        />
      ) : (
        <React.Fragment>
          <div className={classes.messageSearch}>
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado
            </Typography>
          </div>
        </React.Fragment>
      )}

      <ModalConfirmBase
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        type={message.type}
        open={message.open}
      />
    </div>
  );
};

export default Laboratory;
